<template>
  <div
    class="el-step is-horizontal is-center"
    style="flex-basis: 15%; margin-right: 0px"
  >
    <div
      class="el-step__head"
      :class="{
        'is-finish': this.$props.stepNumber < this.$props.currentStep,
        'is-process': this.$props.stepNumber === this.$props.currentStep,
        'is-wait': this.$props.stepNumber > this.$props.currentStep,
      }"
    >
      <div class="el-step__line" style="margin-right: 0px">
        <i class="el-step__line-inner" :style="getLineStyle()"></i>
      </div>
      <div class="el-step__icon is-text">
        <div class="el-step__icon-inner">
          <router-link
            v-if="this.$props.data"
            style="text-decoration: none"
            :to="{ name: this.$props.stepRouteName }"
          >
            <span :style="getTextColor()">{{ this.$props.stepNumber }}</span>
          </router-link>
          <span v-else :style="getTextColor()">{{
            this.$props.stepNumber
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageSteps",
  props: {
    data: {
      Type: Object,
      default: undefined,
    },
    totalSteps: {
      type: Number,
      default: 1,
    },
    stepNumber: {
      type: Number,
      default: 1,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    stepRouteName: {
      type: String,
      default: "",
    },
  },
  methods: {
    getTextColor() {
      if (this.$props.stepNumber < this.$props.currentStep) {
        return "color:#409EFF";
      }
      if (this.$props.stepNumber === this.$props.currentStep) {
        return "color:#303133";
      }
      if (this.$props.stepNumber > this.$props.currentStep) {
        return "color:#C0C4CC";
      }
    },
    getLineStyle() {
      let stepMs = 0;
      switch (this.$props.stepNumber) {
        case 2:
          stepMs = 150;
          break;
        case 3:
          stepMs = 300;
          break;
        case 4:
          stepMs = -450;
          break;
        case 5:
          stepMs = -600;
          break;
        case 6:
          stepMs = -750;
          break;
        case 7:
          stepMs = -900;
          break;
        case 8:
          stepMs = -1050;
          break;
        case 9:
          stepMs = -1200;
          break;
        case 10:
          stepMs = -1350;
          break;
      }
      if (this.$props.stepNumber < this.$props.currentStep) {
        return `transition-delay: ${stepMs}ms; border-width: 1px; width: 100%;`;
      }
      return `transition-delay: ${stepMs}ms; border-width: 0px; width: 0%;`;
    },
  },
};
</script>
